import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CategoryComponent} from './app.component';
import { SharedModule } from '../shared/module';
import {BambuserPlaylistComponent} from '../../component/bambuser-playlist/app.component';
@NgModule({
  declarations: [
    CategoryComponent,
  ],
  imports: [CommonModule, SharedModule, BambuserPlaylistComponent],
  exports: [CategoryComponent],
})
export class CategoryModule {}
